import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';

import styles from '../../index.module.css';

const ProgressTitle = ({ bonus }) => {
  const { t } = useI18n();
  const { remainCount, freespinCount } = bonus;

  return (
    <>
      <Box>
        <AText
          breed="R"
          size="s"
          color="po_txt_color_3"
          className={styles.progressTitle}
        >
          {t('web.personaloffice.bonuses.remaining.bonus')}
        </AText>
        <AText breed="B" size="s" color="po_txt_color_1">
          {t('account.bonusCard.freespins.countValue', [
            remainCount,
            freespinCount
          ])}
        </AText>
      </Box>
    </>
  );
};

export default ProgressTitle;
